import { useCallback, useRef, useState } from 'react';
import { toPng } from 'html-to-image';

/**
 * Hook that renders an off-screen node to PNG and triggers a download.
 * - Waits for fonts to load before rasterizing (prevents mis-rendered Alegreya)
 * - Ensures the element is fully laid out before capture
 */
export function useDownloadStoryCard() {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const download = useCallback(async (filename = 'my-birth-archetype.png') => {
    if (!ref.current || busy) return;
    setBusy(true);
    setError('');
    try {
      if (document.fonts?.ready) {
        try { await document.fonts.ready; } catch { /* noop */ }
      }
      await new Promise((r) => setTimeout(r, 120));

      const dataUrl = await toPng(ref.current, {
        cacheBust: true,
        width: 1080,
        height: 1920,
        pixelRatio: 1,
        backgroundColor: '#E8E0D5',
        style: { transform: 'scale(1)', transformOrigin: 'top left' },
      });

      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (e) {
      console.error('Story card download failed:', e);
      setError('Could not save image. Please try a modern browser.');
    } finally {
      setBusy(false);
    }
  }, [busy]);

  return { ref, download, busy, error };
}
